// extracted by mini-css-extract-plugin
export default {"tickets-list":"tickets-list_tickets-list__kpNka","show-more":"tickets-list_show-more__2DGC4"};